export interface TelemetryDataPoint {
  value: number;
  timestamp: number;
}

export interface TelemetryMetricResponse {
  name: string;
  unit: string | null;
  data: TelemetryDataPoint[];
}

export const ALL_METRICS = [
  'power_supply_voltage',
  'battery_voltage',
  'power_amplifier_1_current',
  'power_amplifier_2_current',
  'power_amplifier_1_temperature',
  'power_amplifier_2_temperature',
  'device_temperature',
  'device_humidity',
  'cpu_temperature',
  'cpu_usage',
  'memory_usage',
  'bridge_temperature',
] as const;

export type MetricName = (typeof ALL_METRICS)[number];
